'use strict';

const selectors = {
    articleDate: '.js-article-date',
    articleTitle: '.js-article-title',
    subCategories: '.tips-sub-categories',
    activeLink: '.link.active',
}

const CONTAINER_OFFSET = 16;

module.exports = {
    init: function () {
        var $linksContainer = $(selectors.subCategories);
        var $activeLink = $linksContainer.find(selectors.activeLink);
        if($activeLink.length) {
            $linksContainer.animate({scrollLeft: $activeLink.offset().left - CONTAINER_OFFSET}, 500)
        }
        $(selectors.articleDate).appendTo(selectors.articleTitle);
    }
};
